// extracted by mini-css-extract-plugin
module.exports = {"link":"Navbar_link__koQk0","active":"Navbar_active__v_AMp","bg_icon":"Navbar_bg_icon__FuMdg"};